import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const userSettingsSearchSchema = z.object({
  tab: z
    .enum(["aboutme", "security", "memberships"])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/(org)/o/$orgSlug/user/settings")({
  validateSearch: userSettingsSearchSchema,
});
